import { IndependentStudentItem } from "@/services/independent";
import { MutationTree } from "vuex";
import { TeacherTeachingState } from "./state";
import { defineVuexName, MODULES } from "@/store/utils";

const mutations: MutationTree<TeacherTeachingState> = {
  //setIndependentListStudentItems
  [defineVuexName(MODULES.TEACHER_TEACHING.COMMITS.SET_INDEPENDENT_LIST_STUDENT_ITEMS)](s: TeacherTeachingState, p: IndependentStudentItem[] | null) {
    s.independentListStudentItems = p;
  },
  //updateIndependentListStudentItems
  [defineVuexName(MODULES.TEACHER_TEACHING.COMMITS.UPDATE_INDEPENDENT_LIST_STUDENT_ITEMS)](s: TeacherTeachingState, p: IndependentStudentItem) {
    const student = s.independentListStudentItems?.find((item) => item.studentId === p.studentId);
    if (student) student.currentItemId = p.currentItemId;
  },
};

export default mutations;
